"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const proj4defs_1 = require("../logic/proj4defs");
const mgrs = require("mgrs");
function parseUrlParameters(url) {
    return _.defaultTo(url, location.search)
        .substr(1) //skip '?'
        .split(';')
        .filter(v => !_.isEmpty(v))
        .map(decodeURIComponent);
}
exports.parseUrlParameters = parseUrlParameters;
function urlParamsToMapArea(url) {
    const selection = parseUrlParameters(url).map(proj4defs_1.mgrs2webmercator);
    return _.isEmpty(selection) ? undefined : {
        topLeft: selection[0],
        bottomRight: selection[1]
    };
}
exports.urlParamsToMapArea = urlParamsToMapArea;
function mapAreaToUrlParams(selection) {
    if (selection !== undefined) {
        const query = [selection.topLeft, selection.bottomRight]
            .map(c => ol.proj.transform(c, proj4defs_1.WEB_MERCATOR, proj4defs_1.WGS84))
            .map(c => mgrs.forward(c, /*accuracy*/ undefined))
            .join(";");
        return `${query}`;
    }
    else {
        return '';
    }
}
exports.mapAreaToUrlParams = mapAreaToUrlParams;



//////////////////
// WEBPACK FOOTER
// ./src/logic/url-parameters.ts
// module id = 120
// module chunks = 0 1